import React from 'react'
import {
  AppWrapper,
  Columns,
  ComponentSize,
  FunnelPage,
  Grid,
  Panel,
  RemoteDataState,
  SpinnerContainer,
  TechnoSpinner,
} from '@influxdata/clockface'

import LogoWithCubo from 'js/components/LogoWithCubo'

import {getMarketplaceStatus} from 'js/client'

import MarketplaceSubscriptionLink from 'js/components/MarketplaceSubscriptionLink'
import SpinnerHeader from './SpinnerHeader'

import {Marketplace} from 'js/types/marketplace'

interface Props {
  statusRoute: string
  marketplace: Marketplace
  accountType: string
}

const MarketplaceSpinner = ({
  statusRoute,
  marketplace,
  accountType,
}: Props): JSX.Element => {
  const [loadingState, setStatus] = React.useState(RemoteDataState.NotStarted)

  React.useEffect(() => {
    setInterval(async () => {
      const data = await getMarketplaceStatus(statusRoute)

      if (data.status == 'subscribed') {
        setStatus(RemoteDataState.Done)
        window.location.reload()
      } else {
        setStatus(RemoteDataState.Loading)
      }
    }, 1000)
  }, [])

  return (
    <AppWrapper type="funnel" className="marketplace-splash">
      <FunnelPage logo={<LogoWithCubo />}>
        <Grid.Row>
          <Grid.Column
            widthSM={Columns.Ten}
            offsetSM={Columns.One}
            widthMD={Columns.Eight}
            offsetMD={Columns.Two}
          >
            <SpinnerHeader
              marketplace={marketplace}
              accountType={accountType}
            />
            <Panel className="marketplace-splash--panel">
              <Panel.Body size={ComponentSize.Large}>
                <SpinnerContainer
                  loading={loadingState}
                  spinnerComponent={
                    <TechnoSpinner
                      className="marketplace-splash--technospinner"
                      diameterPixels={100}
                    />
                  }
                  className="marketplace-splash--spinner"
                />
                This could take <strong>a few minutes</strong> — don’t close
                this window until verification is complete.
              </Panel.Body>
            </Panel>
          </Grid.Column>
        </Grid.Row>
        <p>Issues?</p>
        <MarketplaceSubscriptionLink marketplace={marketplace} />
        <p>
          Or talk to{' '}
          <a href="mailto:support@influxdata.com" target="_blank">
            support@influxdata.com
          </a>
        </p>
      </FunnelPage>
    </AppWrapper>
  )
}

export default MarketplaceSpinner
